export const getPromotionStyles = ({
  currentPromotionPage = null,
  promotionTypeCode,
}: {
  currentPromotionPage?: null | boolean;
  promotionTypeCode?: string;
}) => {
  const isNLP = promotionTypeCode === 'NLP';
  const backgroundColor = isNLP ? 'green' : undefined;
  const isLink = !currentPromotionPage;

  return {
    backgroundColor,
    isLink,
    withChevron: !isNLP,
  };
};
